const calcWbCommission = (p, market, isFinalPrice = false) => {
  const INCREASED_COMMISSION = 7.2;

  const WB_STAFF = 0;
  const WB_COEFF = {
    // зависит от магазина
    'B-WHITE': 1,
    'B-MAX': 1,
    'U-RURU': 1,
    'WB-4': 1,
    'WB-5': 1,
  };

  const sizes_package = {
    width: '',
    height: '',
    depth: '',
    unit: '',
    weight: '',
    unit_weight: '',
    volume: '',
  };

  const isFine = true;
  const CONST_FINE = 0; //10; //штраф за опоздание в процентах
  const CONST_MIN_FINE = 0; //100; //мин штраф за опоздание в рублях

  // promotion - акция установленая площадкой вб
  let { sale = 0, price, package_rub = 20, wholesale_packaging = 0, isPromotionFail = false, is_wb_stock = false } = p;

  let staff = package_rub; // расходы в офис в рублях
  const delivery = p.delivery_cost * (WB_COEFF[market] || 1); //ПОКА СТАВИМ СТАРУЮ

  const percent_commission = p.commission === 0 ? 15 : Math.ceil(p.commission) || 15;
  const increased_commission = p.increasedCommission + INCREASED_COMMISSION; //isPromotionFail && p.increasedCommission ? p.increasedCommission + INCREASED_COMMISSION : INCREASED_COMMISSION;
  // если не проходим по акции, выставляем цену с учетом повышенной комиссии

  const sale_value = (price * sale) / 100;

  const all_sale = isFinalPrice ? 0 : parseFloat(sale_value);

  const final_price = price - all_sale;

  const percent = (final_price * percent_commission) / 100;
  let percent_increased = (final_price * increased_commission) / 100;

  if (is_wb_stock) {
    percent_increased = 0;
    staff = 0;
    wholesale_packaging = 0;
  }

  const fine = isFine ? Math.max((final_price * CONST_FINE) / 100, CONST_MIN_FINE) : 0; // штраф

  const all_services = parseFloat(percent) + parseFloat(percent_increased) + parseFloat(delivery) + parseFloat(fine); // все расходы маркетплейса
  const tax = (final_price - all_services) * 0.06; // налог

  const all_expenses = all_services + tax + WB_STAFF + staff + wholesale_packaging;
  return {
    volume: (p.sizes_package || sizes_package).volume,
    sizes_package: p.sizes_package,
    percent: Math.ceil(percent),
    percent_increased: Math.ceil(percent_increased),
    increased_commission,
    percent_commission,
    delivery: Math.ceil(delivery),
    staff,
    sale,
    wb_staff: WB_STAFF,
    final_price: Math.round(final_price),
    sale_value: Math.ceil(sale_value),
    fine: Math.ceil(fine),
    wholesale_packaging,
    all: Math.ceil(all_expenses),
    tax: Math.ceil(tax),
  };
};

export const calcWbProfit = (p = {}, market, isFinalPrice = false) => {
  const commission = calcWbCommission(p, market, isFinalPrice);
  const price = commission.final_price; // цена с учетом скидки (по которой покупатель покупает)
  // const price = p.price;

  return Math.ceil(price - p.purchase * (p.quantity || 1) - commission.all);
};

export const calcWbMarginality = (p, market, isFinalPrice) => {
  if (p.purchase) {
    return ((calcWbProfit(p, market, isFinalPrice) * 100) / (p.purchase * (p.quantity || 1))).toFixed(1);
  }
  return '-';
};

export const calcWbSPP = (init_price, price) => {
  let spp = ((price - init_price) * 100) / init_price;
  spp = spp ? spp.toFixed(0) : '';
  return spp;
};

export default calcWbCommission;
